import * as Yup from 'yup';
import { phoneNumberRequiredValidation, textFieldValidation } from "common/utils/validationHelpers";

export const referralValidationSchema = Yup.object().shape({
    referringForJob: Yup.string()
        .required("Job opening is required"),

    resume: Yup.string().required("Resume is required"),

    name: Yup.string()
        .required("Name is required")
        .min(2, "Name must be at least 2 characters")
        .max(255, "Name must not exceed 255 characters")
        .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces"),

    email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),

    phoneNumber: phoneNumberRequiredValidation(),

    currentEmployer: textFieldValidation("Current employer", false, 100),
    experience: Yup.number()
        .nullable()
        .transform((value, originalValue) => originalValue === "" ? null : value)
        .min(0, "Experience cannot be negative")
        .test(
            "max-one-decimal-place",
            "Experience can have at most 1 decimal place",
            (value) => value == null || Number.isInteger(value * 10)
        )
        .max(45, "Experience must not exceed 45 years"),
    relationWithEmployee: textFieldValidation("Relation with employee", true, 100),

    referralFeedback: Yup.string()
        .nullable()
        .test('word-count', 'Feedback must be between 1 and 500 words', function (value) {
            if (!value) return true;
            const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
            return wordCount >= 1 && wordCount <= 500;
        }),
});
